<template>
<div class="chapter">
<div class="inner_page">
      ﻿
<meta content="text/html; charset=utf-8" http-equiv="Content-Type"/><meta content="text/html; charset=UTF-8"/><title> STRANGE FIRE </title><link href="default.css" rel="stylesheet" type="text/css"/>
<p class="bkt">S<span class="small">TRANGE</span> <span class="bkt1">F<span class="small">IRE</span></span> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// halftitle.vue?57d0d5ec